import { AppCookiesConfig } from "types"

const cookies: AppCookiesConfig = {
  isChannelMember: 'isChannelMember',
}

export default cookies
